<template>
<div id="mirrorMode" class="mirrorMode">
  <div @click="isMirrorMenuModal = true" class="mirrorGlobalMenu">
    <img src="@/assets/images/mirror/commons/commons-menu.svg" alt="Menu">
  </div>
  <MirrorMenuModal
    v-if="isMirrorMenuModal"
    @closeMenu="isMirrorMenuModal = false" />
  <ScreenSaverModal
    v-if="isScreenSaver"
    @closeScreenSaver="isScreenSaver = false" />
</div>
</template>

<script>
import MirrorMenuModal from '@/components/mirror/MirrorMenuModal'
import ScreenSaverModal from '@/components/mirror/ScreenSaverModal'
import ScreenSaver from '@/assets/class/ScreenSaver'

export default {
  mixins: [ScreenSaver],
  components: {
    MirrorMenuModal,
    ScreenSaverModal
  },
  data () {
    return {
      isMirrorMenuModal: false,
      isScreenSaver: false
    }
  }
}
</script>

<style lang="scss" scoped>
.mirrorMode {
  width: 100%;
  height: 100%;
  background-color: #000000;
  .mirrorGlobalMenu {
    @include mirrorMenuBtn;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/mirror/MirrorMode.vue